@if (errors?.length) {
  <div class="row mt-4 mb-4">
    <div class="col">
      <div class="error-container">
        @if (errors?.length > 1) {
          <div>{{ 'trade.multi-order.error.header' | transloco }}</div>
          <ul class="list" data-zid="error-list">
            @for (error of errors; track $index) {
              <li>{{ error | transloco }}</li>
            }
          </ul>
        } @else {
          <div class="mb-3" data-zid="single-error">{{ errors[0] | transloco }}</div>
        }
      </div>
    </div>
  </div>
}
